$(() => {
  $('.extra-carousel-video-autoplay').each((index, carousal) => {
    $(carousal).on('ready.flickity', (readyEvent) => {
      const autoPlayDuration = $(readyEvent.target).data('autoplay');
      const pageDots = $(readyEvent.target).data('pagedots');
      if (autoPlayDuration && pageDots) {
        $(readyEvent.target).find('ol.flickity-page-dots .dot').each((index, dotElement) => {
          $(dotElement).append('<span></span>');
          $(dotElement).find('span').css('animation-duration',`${autoPlayDuration}ms`);
        });
      }
      $('.hero-banner-slider .flickity-enabled').on('change.flickity', (event, slideNo) => {
        const flickity = $(event.target).data('flickity');
        const cell = 'cells' in flickity && slideNo in flickity.cells ? flickity.cells[slideNo] : [];
        if ('element' in cell) {
          $(cell.element).find('video').each((slideNo, element) => {
            element.pause();
            element.currentTime = 0;
            element.play();
          });
        }
      });
    });
  });
});